// Organization
export const buildOrganizationSchema = () => ({
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "ezClocker",
    url: "https://ezclocker.com",
    logo: "https://ezclocker.com/public/images/ezclocker_logo.png"
});

// Software (dynamic)
export const buildSoftwareSchema = (plans = {}) => ({
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "ezClocker",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web, iOS, Android",
    offers: Object.keys(plans).length > 0 ? Object.keys(plans).map((key) => ({
        "@type": "Offer",
        name: `${key} plan`,
        price: plans[key].monthly.replace("$", ""),
        priceCurrency: "USD"
    })) : []
});

// FAQ
export const buildFAQSchema = (faqData = []) => ({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqData.map(faq => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
            "@type": "Answer",
            text: faq.answer.replace(/<[^>]*>/g, '')
        }
    }))
});

// Reviews (Landing page)
export const buildReviewSchema = (customers = []) => ({
    "@context": "https://schema.org",
    "@type": "Product",
    "@id": "https://ezclocker.com/#product",
    name: "ezClocker",
    image: "https://ezclocker.com/public/images/ezclocker_logo.png",
    description: "Highly rated time tracking app for small businesses.",
    aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "5",
        reviewCount: customers.length > 0 ? customers.length.toString() : "1"
    },
    review: customers.map(c => ({
        "@type": "Review",
        itemReviewed: {
            "@id": "https://ezclocker.com/#product"
        },
        author: {
            "@type": "Person",
            name: c.customerName
        },
        reviewRating: {
            "@type": "Rating",
            ratingValue: "5",
            bestRating: "5",
            worstRating: "1"
        },
        reviewBody: `Review from ${c.customerName} at ${c.customerCompany}`
    }))
});

// Contact
export const buildContactSchema = ({ phone, email }) => ({
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "ezClocker",
    url: "https://ezclocker.com",
    logo: "https://ezclocker.com/public/images/ezclocker_logo.png",
    contactPoint: [
        {
            "@type": "ContactPoint",
            telephone: phone,
            contactType: "customer support",
            email: email
        }
    ]
});

// Breadcrumbs (For static pages to trigger Rich Result validation)
export const buildBreadcrumbSchema = (pageName, pagePath) => ({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
        {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://ezclocker.com/"
        },
        {
            "@type": "ListItem",
            "position": 2,
            "name": pageName,
            "item": `https://ezclocker.com${pagePath}`
        }
    ]
});